import React from "react";
import SocialMedia from "./SocialMedia";

export default function Footer() {
    return (
        <div id="footer">
            <div id="footer-content">
                <p>&copy;2026 by Osso City Lighting. All Rights Reserved.</p>
                <SocialMedia />
            </div>
        </div>
    );
}
